import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { display, width } from 'styled-system';
import type { DisplayProps, WidthProps } from 'styled-system';

import type { PrismicImage } from 'common/components/PrismicResponsiveImage';
import PrismicResponsiveImage from 'common/components/PrismicResponsiveImage';
import { aspectRatio as aspectRatioUtil } from 'common/theme/system-utilities';
import type { AspectRatioProps } from 'common/theme/system-utilities';
import { SHOP_THE_LOOK_ASPECT_RATIO } from '../constants';

interface ResponsiveImageProps {
  image: PrismicImage;
}

const Container = styled.div<WidthProps & DisplayProps & AspectRatioProps>`
  ${width};
  ${display};
  ${aspectRatioUtil};
`;

const containerStyles: Partial<ComponentProps<typeof Container>> = {
  width: '100%',
  display: 'block',
};

const StyledPrismicImage = styled(PrismicResponsiveImage)<
  WidthProps & DisplayProps & AspectRatioProps
>`
  ${width};
  ${display};
  ${aspectRatioUtil};
`;

const styledPrismicImageStyles: Partial<ComponentProps<typeof StyledPrismicImage>> = {
  width: '100%',
  display: 'block',
};

const ResponsiveImage = ({ image }: ResponsiveImageProps) => {
  return (
    <Container {...containerStyles} aspectRatio={SHOP_THE_LOOK_ASPECT_RATIO} width="100%">
      <StyledPrismicImage
        {...styledPrismicImageStyles}
        highPriority
        image={image}
        aspectRatio={SHOP_THE_LOOK_ASPECT_RATIO}
      />
    </Container>
  );
};

export default ResponsiveImage;
